// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js. ex: import DropdownController from "./dropdown_controller";
import { application } from "./application";
import { registerNiiwinControllers } from "@niiwin/core";

// Import and register all Niiwin Stimulus controllers (first)
registerNiiwinControllers(application);

// Load this app's controllers (second, in case they override Niiwin controllers)
// application.register("dropdown", DropdownController)
import { Application } from "@hotwired/stimulus";

import BasicSelectController from "./basic_select_controller";
import ExternalLinksController from "./external_links_controller";
import FormsContentSectionsController from "./forms/content_sections_controller";
import FormsFilterrificFormController from "./forms/filterrific_form_controller";
import FormsSlugController from "./forms/slug_controller";
import FormsSortableController from "./forms/sortable_controller";
import PopoverController from "./popover_controller";
import TrixController from "./trix_controller";
import VideoEmbedController from "./video_embed_controller";

// Load this app's controllers (second, in case they override Niiwin controllers)
// application.register("dropdown", DropdownController)
application.register("basic-select", BasicSelectController);
application.register("external-links", ExternalLinksController);
application.register("forms--content-sections", FormsContentSectionsController);
application.register("forms--filterrific-form", FormsFilterrificFormController);
application.register("forms--slug", FormsSlugController);
application.register("forms--sortable", FormsSortableController);
application.register("popover", PopoverController);
application.register("trix", TrixController);
application.register("video-embed", VideoEmbedController);
